<template>
  <q-card flat>
    <q-card-section class="no-padding">
      <q-banner class="bg-blue text-white text-subtitle1" inline-actions>
        لیست موجودی گروه کالاها
        <template v-slot:action>
          <q-btn flat round icon="close" v-close-popup/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section class="no-padding">
      <q-card flat>
        <q-card-actions>
          <q-btn label="دانلود" icon="download" color="blue" flat class="q-ml-sm">
            <download-csv
                name="inventoryList"
                :data="goodsGroupOptions">
              <span></span>
            </download-csv>
            <q-tooltip>
              دانلود گزارش
            </q-tooltip>
          </q-btn>
          <q-btn icon="print" flat round color="indigo" @click="loadReport">
            <q-tooltip>
              چاپ
            </q-tooltip>
          </q-btn>
        </q-card-actions>
      </q-card>
    </q-card-section>
    <q-card-section>
      <q-table
          class="my-sticky-header-table"
          flat
          :data="goodsGroupOptions"
          row-key="ID"
          :pagination="pagination"
          :hide-header="$q.screen.lt.md">
        <template v-slot:header>
          <q-tr>
            <td class="text-center text-subtitle2">عنوان گروه</td>
            <td class="text-center text-subtitle2">قیمت خرید روز
            </td>
            <td class="text-center text-subtitle2">قیمت خرید اصلی
            </td>
            <td class="text-center text-subtitle2">تاریخ آخرین خرید
            </td>
            <td class="text-center text-subtitle2">قیمت لیست
            </td>
            <td class="text-center text-subtitle2">قیمت نقد کارتن
            </td>
            <td class="text-center text-subtitle2">قیمت نقد بسته
            </td>
            <td class="text-center text-subtitle2">قیمت اتحادیه
            </td>
            <td class="text-center text-subtitle2">کل</td>
            <td class="text-center text-subtitle2">مرکزی</td>
            <td class="text-center text-subtitle2">فروشگاه</td>
            <td class="text-center text-subtitle2">پل پنجم</td>
            <td class="text-center text-subtitle2">کارخانه صاف</td>
            <td class="text-center text-subtitle2">دیجیکالا</td>
            <td class="text-center text-subtitle2">ضایعات</td>
          </q-tr>
          <q-tr class="q-mb-md">
            <td class="text-center text-subtitle2">
              جمع کل
            </td>
            <td class="text-center text-subtitle2">
              <q-chip square text-color="white" color="blue-grey"
                      v-if="$store.state.roles.some(v=>['admin','can_see_by_price'].includes(v))"
                      :label="lodash.sumBy(goodsGroupOptions, item=> item.BuyDay_Price).toLocaleString()"/>
            </td>
            <td class="text-center text-subtitle2">
              <q-chip square text-color="white" color="blue-grey"
                      v-if="$store.state.roles.some(v=>['admin','can_see_by_price'].includes(v))"
                      :label="lodash.sumBy(goodsGroupOptions.filter(rec=>rec.BuyLast_Price), item=> item.BuyLast_Price).toLocaleString()"/>

            </td>
            <td class="text-center text-subtitle2"></td>
            <td class="text-center text-subtitle2">
              <q-chip square text-color="white" color="blue-grey"
                      :label="lodash.sumBy(goodsGroupOptions, item=> item.List_Price).toLocaleString()"/>

            </td>
            <td class="text-center text-subtitle2">
              <q-chip square text-color="white" color="blue-grey"
                      :label="lodash.sumBy(goodsGroupOptions, item=> item.SaleG_Price_Box).toLocaleString()"/>

            </td>
            <td class="text-center text-subtitle2">
              <q-chip square text-color="white" color="blue-grey"
                      :label="lodash.sumBy(goodsGroupOptions, item=> item.SaleG_Price).toLocaleString()"/>
            </td>
            <td class="text-center text-subtitle2">
              <q-chip square text-color="white" color="blue-grey"
                      :label="lodash.sumBy(goodsGroupOptions, item=> item.Price).toLocaleString()"/>
            </td>
            <td class="text-center text-subtitle2">
              <q-chip square text-color="white" color="blue-grey"
                      :label="lodash.sumBy(goodsGroupOptions, item=> item.Goods_Stock)"/>
            </td>
            <td class="text-center text-subtitle2">
              <q-chip square text-color="white" color="blue-grey"
                      :label="lodash.sumBy(goodsGroupOptions, item=> item.GStor1)"/>
            </td>
            <td class="text-center text-subtitle2">
              <q-chip square text-color="white" color="blue-grey"
                      :label="lodash.sumBy(goodsGroupOptions, item=> item.GStor2)"/>
            </td>
            <td class="text-center text-subtitle2">
              <q-chip square text-color="white" color="blue-grey"
                      :label="lodash.sumBy(goodsGroupOptions, item=> item.GStor3)"/>
            </td>
            <td class="text-center text-subtitle2">
              <q-chip square text-color="white" color="blue-grey"
                      :label="lodash.sumBy(goodsGroupOptions, item=> item.GStor4)"/>
            </td>
            <td class="text-center text-subtitle2">
              <q-chip square text-color="white" color="blue-grey"
                      :label="lodash.sumBy(goodsGroupOptions, item=> item.GStor6)"/>
            </td>
            <td class="text-center text-subtitle2">
              <q-chip square text-color="white" color="blue-grey"
                      :label="lodash.sumBy(goodsGroupOptions, item=> item.GStor5)"/>
            </td>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr v-if="$q.screen.lt.md" :props="props" class="my-class">
            <q-td>
              <q-card flat>
                <q-card-section class="no-padding" horizontal>
                  <q-card>
                    <q-card-section class="no-padding">
                      <q-banner class="q-pa-none">
                        {{ props.row.title }}
                      </q-banner>
                    </q-card-section>
                  </q-card>
                  <q-space/>
                  <q-card>
                    <q-card-section>
                      <q-chip :size="$q.screen.lt.md?'md':'md'" square flat label="موجودی کل">
                        <q-badge :color="props.row.Goods_Stock===0?'red-14':'purple'" class="q-ml-xs">
                          {{ props.row.Goods_Stock }}
                        </q-badge>
                      </q-chip>
                      <q-space/>
                    </q-card-section>
                  </q-card>
                </q-card-section>
              </q-card>
            </q-td>
          </q-tr>
          <q-tr v-if="!$q.screen.lt.md" :props="props" class="my-class">
            <q-tooltip>
              {{ props.row.Group_Name }}
            </q-tooltip>
            <q-td class="text-subtitle2">
              {{ props.row.Group_Name }}
            </q-td>
            <q-td class="text-center">
              <q-chip
                  v-if="props.row.BuyDay_Price && props.row.BuyDay_Price>0 && $store.state.roles.some(v=>['admin','can_see_by_price'].includes(v))"
                  :label="props.row.BuyDay_Price.toLocaleString()" color="red" text-color="white" square/>
            </q-td>
            <q-td class="text-center">
              <q-chip v-if="props.row.BuyLast_Price"
                      :label="props.row.BuyLast_Price" color="red" text-color="white" square/>
            </q-td>
            <q-td class="text-center">
              <q-chip v-if="props.row.BuyDay_Date"
                      :label="props.row.BuyDay_Date" color="red" text-color="white" square/>
            </q-td>

            <q-td class="text-center">
              <q-chip v-if="props.row.List_Price && props.row.List_Price>0"
                      :label="props.row.List_Price.toLocaleString()" color="purple" text-color="white" square/>
            </q-td>
            <q-td class="text-center">
              <q-chip v-if="props.row.SaleG_Price_Box && props.row.SaleG_Price_Box>0"
                      :label="props.row.SaleG_Price_Box.toLocaleString()" color="blue" text-color="white" square/>
            </q-td>
            <q-td class="text-center">
              <q-chip v-if="props.row.SaleG_Price && props.row.SaleG_Price>0"
                      :label="props.row.SaleG_Price.toLocaleString()" color="teal" text-color="white" square/>
            </q-td>
            <q-td class="text-center">
              <q-chip v-if="props.row.Price && props.row.Price>0"
                      :label="props.row.Price.toLocaleString()" color="green" text-color="white" square/>
            </q-td>
            <q-td class="text-center" style="width: 100px">
              <q-chip v-if="props.row.Goods_Stock" :label="props.row.Goods_Stock" text-color="white" color="teal"/>
            </q-td>
            <q-td class="text-center text-bold" style="width: 100px">
              <q-chip v-if="props.row.GStor1" :label="props.row.GStor1" text-color="white" color="purple"/>
            </q-td>
            <q-td class="text-center text-bold" style="width: 100px">
              <q-chip v-if="props.row.GStor2" :label="props.row.GStor2" text-color="white" color="blue-grey"/>
            </q-td>
            <q-td class="text-center text-bold" style="width: 100px">
              <q-chip v-if="props.row.GStor3" :label="props.row.GStor3" text-color="white" color="grey"/>
            </q-td>
            <q-td class="text-center text-bold" style="width: 100px">
              <q-chip v-if="props.row.GStor4" :label="props.row.GStor4" text-color="white" color="blue"/>
            </q-td>
            <q-td class="text-center text-bold" style="width: 100px">
              <q-chip v-if="props.row.GStor6" :label="props.row.GStor6" text-color="white" color="blue"/>
            </q-td>
            <q-td class="text-center text-bold" style="width: 100px">
              <q-chip v-if="props.row.GStor5" :label="props.row.GStor5" text-color="white" color="blue"/>
            </q-td>
          </q-tr>
        </template>
      </q-table>

    </q-card-section>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "GroupInventoryList",
  props: {
    goodsGroupCode: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      goodsGroupOptions: [],
      pagination: {
        rowsPerPage: 10
      }
    }
  },
  methods: {
    ...mapActions({
      setGoodsGroupList: 'Products/getGoodsGroupList'
    }),
    async loadReport() {
      await this.openURL(`https://report.norl.ir/Reports/report/ECAPPV2/گزارشات مرتبط با کالا/خلاصه اطلاعات گروه کالایی انبارها?rs:Format=PDF&GoodsGroupList=${this.goodsGroupCode.map(item => item.Group_ID).join(',')}&rc:Parameters=False&rc:Zoom=Page Width`)
    },
  },
  watch: {
    selectedGoodsGroup: function (val) {
      if (!val || val.length === 0) {
        this.goods = []
      }
    }
  },
  created() {
    this.setGoodsGroupList(this.goodsGroupCode).then((res) => {
      this.goodsGroupOptions = res
    })
  }
}
</script>

<style scoped>

</style>